export default __webpack_public_path__ + "static/media/post-3.2b4e9211.png";